module.exports = __webpack_public_path__ + "img/cardboard-box.3f890410.png";